export { Switch } from '@blueprintjs/core'